import { type Data } from 'core/domain/Request'
import { type HttpClientConfig, type HttpClientInterface } from 'core/infra/http/HttpClient'

import { mapApiToUserAccount, type RawUserAccount } from './userAccountMapper'

type UpdateUserAccountParams = {
  data: {}
  config?: Partial<HttpClientConfig>
}

export type UserAccountRepositoryDependencies = {
  httpClient: HttpClientInterface
}

export class UserAccountRepository {
  private httpClient: HttpClientInterface

  constructor({ httpClient }: UserAccountRepositoryDependencies) {
    this.httpClient = httpClient
  }

  async getUserAccount(config?: Partial<HttpClientConfig>) {
    const endpoint = `/api/v2/account`

    const {
      data: { data },
    } = await this.httpClient.get<Data<RawUserAccount>>(endpoint, config)

    return mapApiToUserAccount(data)
  }

  async updateUserAccount({ data, config }: UpdateUserAccountParams) {
    const endpoint = `/api/v2/account`

    const result = await this.httpClient.put<Data<RawUserAccount>>(endpoint, data, config)

    return mapApiToUserAccount(result.data.data)
  }
}
